
import { useAuth } from "@/contexts/AuthContext";
import { ChildView } from "@/components/dashboard/ChildView";
import { ParentView } from "@/components/dashboard/ParentView";
import { useEffect } from "react";

export default function DashboardPage() {
  const { currentUser } = useAuth();

  useEffect(() => {
    document.title = "Dashboard | Shekel";
  }, []);

  if (!currentUser) {
    return null;
  }

  return (
    <div>
      {currentUser.role === 'child' ? (
        <ChildView />
      ) : (
        <ParentView />
      )}
    </div>
  );
}
